// import { type TrackingInformation } from "../../../../../../utilities/product-link-tracking";
import { registerVueProductSpec } from "../../../../../../utilities/spec-updater/registerVueProductSpec";
// import { type OverwriteSettings } from "../../../../../commons/product/overwrite-settings";
// import { type IProductPictureInfo } from "../../list-item";

interface CommonRowProps {
    secondsLeft?: number | undefined;
    getSecondsLeft?(): number | undefined;
}

interface OnePerRowProps extends CommonRowProps {
    // isGalleryItem: boolean;
    productId?: number | undefined;
    // productName?: string | undefined;
    // link?: string | undefined;
    // overlayText?: string | undefined;
    // overlayTextType?: string | undefined;
    // thirdPartyStamp: boolean;
    // relatedAuctionStamp: boolean;
    // relatedShopStamp: boolean;
    // mobile: boolean;
    // secondsLeft?: number | undefined;
    // indexOfList?: number | undefined;
    // timeIsNotStarted: boolean;
    // imageInfo?: IProductPictureInfo | undefined;
    // page?: number | undefined;
    // isAuction: boolean;
    isShop: boolean;
    // isBuynow: boolean;
    // trackingInfo?: TrackingInformation | undefined;
    // productValue?: number | undefined;
    // hasBid: boolean;
    // price?: number | undefined;
    // scaleOfScreen: number;
    // overwriteActionButtonText?: string | undefined;
    // overwriteActionButton: boolean;
    // overwriteSettings?: OverwriteSettings | undefined;
    // actionButtonLoading: boolean;
    // expectedContentType?: string | undefined;
    //visible: boolean;
}

interface MultiColumnProps extends CommonRowProps {
    productId?: number | undefined;
    // productName?: string | undefined;
    // page?: number | undefined;
    // imageInfo?: IProductPictureInfo | undefined;
    // overlayText?: string | undefined;
    // overlayTextType?: string | undefined;
    //overlayTextLink: string,
    // indexOfList?: number | undefined;
    // thirdPartyStamp: boolean;
    // relatedAuctionStamp: boolean;
    // relatedShopStamp: boolean;
    // isAuction: boolean;
    // isBuynow: boolean;
    isShop: boolean;
    // productValue?: number | undefined;
    // price?: number | undefined;
    // mobile: boolean;
    //secondsLeft?: number | undefined;
    // timeIsNotStarted: boolean;
    // overwriteSettings?: OverwriteSettings | undefined;
    // link?: string | undefined;
    // hasBid: boolean;
    // priceComparisonEnabled: boolean;
    // trackingInfo?: TrackingInformation | undefined;
    // scaleOfScreen: number;
}

interface InitializedTimeData {
    initializedDate: Date | undefined;
    initialSeconds: number | undefined;
}

import { reactive, type Ref } from "vue";
import { registerVueProductCountdown } from "../../../../../../utilities/countdown";
import { type UpdatedProductItem } from "../../../../../../utilities/spec-updater/types";
import { isValidSecondsleft } from "../../../../../commons/product/auction/countdown";

interface CommonProductListEmitter {
    (
        eventName: "update:productId",
        productId: UpdatedProductItem["productId"]
    ): void;
    (
        eventName: "update:productName",
        productName: UpdatedProductItem["productName"]
    ): void;
    (eventName: "update:link", link: UpdatedProductItem["link"]): void;
    (
        eventName: "update:overlayText",
        overlayText: UpdatedProductItem["overlayText"]
    ): void;
    (
        eventName: "update:overlayTextType",
        overlayTextType: UpdatedProductItem["overlayTextType"]
    ): void;
    (
        eventName: "update:thirdPartyStamp",
        thirdPartyStamp: UpdatedProductItem["thirdPartyStamp"]
    ): void;
    (
        eventName: "update:relatedAuctionStamp",
        relatedAuctionStamp: UpdatedProductItem["relatedAuctionStamp"]
    ): void;
    (
        eventName: "update:relatedShopStamp",
        relatedShopStamp: UpdatedProductItem["relatedShopStamp"]
    ): void;
    (
        eventName: "update:secondsLeft",
        timeTotalSeconds: UpdatedProductItem["timeTotalSeconds"]
    ): void;
    (
        eventName: "update:timeIsNotStarted",
        timeIsNotStarted: UpdatedProductItem["timeIsNotStarted"]
    ): void;
    //emit("update:overlayTextLink", item.overlayTextLink);
    (
        eventName: "update:isAuction",
        isAuction: UpdatedProductItem["isAuction"]
    ): void;
    (eventName: "update:isShop", isShop: UpdatedProductItem["isShop"]): void;
    (
        eventName: "update:isBuynow",
        isBuyNow: UpdatedProductItem["isBuyNow"]
    ): void;
    (
        eventName: "update:productValue",
        value: UpdatedProductItem["value"]
    ): void;
    (eventName: "update:hasBid", hasBid: UpdatedProductItem["hasBid"]): void;
    (eventName: "update:price", price: UpdatedProductItem["price"]): void;
}

interface ProductRegistration extends ProductRegistrationResult {
    handlers: ProductRegistrationUpdateHandlerObject[];
}

export interface ProductRegistrationResult {
    addHandler(
        handler: ProductRegistrationUpdateHandler
    ): ProductRegistrationUpdateHandler;
}

interface ProductRegistrationUpdateHandlerObject
    extends ProductRegistrationUpdateHandler {
    destroy(): void;
}
interface ProductRegistrationUpdateHandler {
    emitter?: CommonProductListEmitter | undefined;
    timeText?: Ref<string> | undefined;
}

function invokeEmitter(
    emit: CommonProductListEmitter,
    item: UpdatedProductItem
) {
    emit("update:productId", item.productId);
    emit("update:productName", item.productName);
    emit("update:link", item.link);
    emit("update:overlayText", item.overlayText);
    emit("update:overlayTextType", item.overlayTextType);
    //emit("update:overlayTextLink", item.overlayTextLink);
    emit("update:thirdPartyStamp", item.thirdPartyStamp);
    emit("update:relatedAuctionStamp", item.relatedAuctionStamp);
    emit("update:relatedShopStamp", item.relatedShopStamp);
    emit("update:secondsLeft", item.timeTotalSeconds);
    emit("update:timeIsNotStarted", item.timeIsNotStarted);
    emit("update:isAuction", item.isAuction);
    emit("update:isShop", item.isShop);
    emit("update:isBuynow", item.isBuyNow);
    emit("update:productValue", item.value);
    emit("update:hasBid", item.hasBid);
    emit("update:price", item.price);
}

function registerSpecAndCountdown(
    props: OnePerRowProps &
        MultiColumnProps & {
            registration?: ProductRegistrationResult | undefined;
        },
    emit: ProductRegistrationUpdateHandler["emitter"],
    timeText: ProductRegistrationUpdateHandler["timeText"]
) {
    let reg = props.registration;
    if (reg == null) {
        console.warn("Created registration inside item component");
        reg = registerProduct({
            props: props,
        });
        //console.trace("adding handler to new registration");
    } else {
        //console.trace("adding handler to existing registration");
    }
    reg.addHandler({
        emitter: emit,
        timeText: timeText,
    });
}

export function ensureInitializedRegistration(
    props: OnePerRowProps &
        MultiColumnProps & {
            registration?: ProductRegistrationResult | undefined;
            visible?: boolean;
        },
    emit: ProductRegistrationUpdateHandler["emitter"],
    timeText: ProductRegistrationUpdateHandler["timeText"] = undefined
) {
    if (props.productId == null) {
        //console.debug("Registration cancelled: productId is null");
        return;
    }

    if (
        props.secondsLeft == null &&
        (props.getSecondsLeft == null || props.getSecondsLeft() == null)
    ) {
        //console.debug("Registration cancelled: secondsLeft is null");
        return;
    }

    if (
        props.isShop &&
        !isValidSecondsleft(
            props.getSecondsLeft ? props.getSecondsLeft()! : props.secondsLeft!
        )
    ) {
        // console.debug(
        //     "Registration cancelled: shop has invalid countdown is null"
        // );
        return;
    }
    if (
        !("visible" in props) ||
        props.visible ||
        document.readyState === "complete"
    ) {
        // console.debug("Registration being called from main thread");
        registerSpecAndCountdown(props, emit, timeText);
    } else {
        // console.debug("Registration being called on load event");
        window.addEventListener(
            "load",
            () => {
                registerSpecAndCountdown(props, emit, timeText);
            },
            {
                once: true,
            }
        );
    }
}

export function registerProduct({
    props,
}: {
    props: OnePerRowProps & MultiColumnProps;
}): ProductRegistrationResult {
    //console.log("regy", props);
    const result: ProductRegistration = {
        handlers: [],
        addHandler(handler) {
            const reg = this;
            const handlerObject: ProductRegistrationUpdateHandlerObject =
                Object.assign<
                    ProductRegistrationUpdateHandler,
                    Omit<
                        ProductRegistrationUpdateHandlerObject,
                        keyof ProductRegistrationUpdateHandler
                    >
                >(handler, {
                    destroy() {
                        const index = reg.handlers.indexOf(this);
                        if (index < 0) return;
                        reg.handlers.splice(index, 1);
                    },
                });
            this.handlers.push(handlerObject);
            return handler;
        },
    };
    const timeData: InitializedTimeData = reactive({
        initializedDate: undefined,
        initialSeconds: undefined,
    });
    if (
        props.productId != null &&
        (!props.isShop ||
            ((props.secondsLeft != null ||
                (props.getSecondsLeft != null &&
                    props.getSecondsLeft() != null)) &&
                isValidSecondsleft(
                    props.getSecondsLeft != null
                        ? props.getSecondsLeft()!
                        : props.secondsLeft!
                )))
    ) {
        // console.log("registering");
        // console.log(props);
        registerVueProductSpec({
            productId: props.productId,
            secondsLeftGetter:
                props.getSecondsLeft != null
                    ? () => props.getSecondsLeft!() ?? 0
                    : () => props.secondsLeft ?? 0,
            callbackUpdatedItem: (item) => {
                timeData.initializedDate = undefined;
                timeData.initialSeconds = undefined;

                for (const handler of result.handlers) {
                    if (handler.emitter != null) {
                        invokeEmitter(handler.emitter, item);
                    }
                }
            },
        });
    }
    if (
        props.productId != null &&
        (props.secondsLeft != null ||
            (props.getSecondsLeft != null && props.getSecondsLeft() != null)) &&
        isValidSecondsleft(
            props.getSecondsLeft != null
                ? props.getSecondsLeft()!
                : props.secondsLeft!
        )
    ) {
        registerVueProductCountdown({
            itemId: props.productId,
            textSetter: (v) => {
                for (const handler of result.handlers) {
                    if (handler.timeText != null) {
                        handler.timeText.value = v;
                    }
                }
            },
            secondsGetter:
                props.getSecondsLeft != null
                    ? () => props.getSecondsLeft!() ?? 0
                    : () => props.secondsLeft ?? 0,
            secondsSetter: (v) => {
                //if (!props.visible) return;
                for (const handler of result.handlers) {
                    if (handler.emitter != null) {
                        handler.emitter("update:secondsLeft", v);
                    }
                }
            },
            getInitializedDate: () => timeData.initializedDate,
            getInitialSeconds: () => timeData.initialSeconds,
            setInitializedDate: (v) => (timeData.initializedDate = v),
            setInitialSeconds: (v) => (timeData.initialSeconds = v),
        });
    }
    return result;
}
